import { render } from "./HeadNav.vue?vue&type=template&id=0f14e8ba"
import script from "./HeadNav.vue?vue&type=script&lang=js"
export * from "./HeadNav.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ts/Desktop/works/vue3_portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__